import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material';
import { TranslateModule } from '@ngx-translate/core';
import { FcPaginatorComponent } from './fc-paginator.component';


@NgModule({
  declarations: [
    FcPaginatorComponent
  ],
  imports: [
    TranslateModule,
    MatButtonModule,
    CommonModule
  ],
  exports: [
    FcPaginatorComponent
  ],
})

export class FcPaginatorModule {}
